import { createSelector } from 'reselect';
import { FLAG_KEYS } from 'lib/constants';
import { getLaunchDarklyFlags } from './getLaunchDarklyFlags';
import { getIsJobLaborTrackingEnabled } from './getIsJobLaborTrackingEnabled';
import { getMaterialPickingEnabled } from './getMaterialPickingEnabled';

const getBarcodeScanningEnabled = createSelector(
  [
    getLaunchDarklyFlags,
    getIsJobLaborTrackingEnabled,
    getMaterialPickingEnabled,
  ],
  (flags, isJobLaborTrackingEnabled, materialPickingEnabled) => {
    const barcodeFlagEnabled =
      flags?.[FLAG_KEYS.BARCODE_SCANNING_ENABLED] || false;

    // Standalone barcode scanning (labor-tracking ERP flow), OR material picking,
    // which is scan-only and already accounts for its own ERP flow condition.
    return (
      (barcodeFlagEnabled && isJobLaborTrackingEnabled) ||
      materialPickingEnabled
    );
  }
);

export { getBarcodeScanningEnabled };
